module.exports = __webpack_public_path__ + "static/media/share-energy.5c875426.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/share-energy.png
// module id = 3285
// module chunks = 0